var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lottie',{staticStyle:{"width":"100%","padding-inline":"80px"},attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }